export default __webpack_public_path__ + "static/media/Login-bg.3dc51177.jpg";